import React from "react";
import SetMessageComponent from "./SetMessageComponent";

function SetTextMessage() {
  return (
    <SetMessageComponent
      messageType="text"
      title="Set Text Confirmation Message"
      description={`Enter the text/SMS confirmation message template below. Keep it concise for SMS delivery. Available tags: <name> the person's first name, <datestr> the date, <timestr> the time, and <link> the reschedule link.`}
    />
  );
}

export default SetTextMessage;